<template>
    <div class="container">
        <header>
            <img src="@/assets/imgs/logo.png" alt="App Logo" class="logo">
            <h2 class="app-name">Tourist Pay</h2>
        </header>
        <img src="@/assets/imgs/ill_welcome.png" alt="Welcome Image" class="welcome-image">
        <h1 class="title">Tourist-Friendly Digital Wallet</h1>
        <p class="description">A convenient and secure way for tourists to make payments using a pre-paid card and QR code technology in Türkiye.</p>
        <router-link to="/chooseAccount" class="primary-btn clickable">Get Started</router-link>
    </div>
</template>

<script lang="ts" setup>
</script>

<style>
header {
    display: flex;
    gap: 4px;
}

header img {
    width: 48px;
    height: 48px;
}

.app-name{
    font-size: 28px;
    margin-top: 8px;
}

.welcome-image {
    width: 100%; /* Scale image to fit */
    margin: 20px 0;
}

.title {
    font-size: 34px;
    margin: 20px 0;
}

.description {
    font-size: 18px;
    margin: 10px 0;
    color: var(--text-light-color);
    opacity: 0.7;
}

</style>
